import shortid from 'shortid'

export const firebaseConfig = {
  apiKey: 'AIzaSyANDoBbrlTFF_cUn2r_-42GMvJnRjDrGfM',
  authDomain: 'tank-xmas.firebaseapp.com',
  databaseURL: 'https://tank-xmas.firebaseio.com',
  projectId: 'tank-xmas',
  storageBucket: 'tank-xmas.appspot.com',
  messagingSenderId: '1039009830975',
  appId: '1:1039009830975:web:836f2dd26dd0900dc4408a',
  measurementId: 'G-JB42MCCTHX'
}

export const uploadCard = (image, $db, namePrefix, callback) => {
  const name = `${namePrefix}-${shortid.generate()}`
  const uploadTask = $db.child(`cards/${name}`).put(image)

  uploadTask.on(
    'state_changed',
    snapshot => {
      // Calculate loader progress?
      console.info('Upload progress', snapshot)
    },
    error => {
      // Handle unsuccessful uploads
      console.error(error)
    },
    () =>
      callback({
        name,
        value: `https://firebasestorage.googleapis.com/v0/b/tank-xmas.appspot.com/o/cards%2F${name}?alt=media`
      })
  )
}
